var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKulturelYerler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#499BD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.546 5.5h4.364c.6 0 1.09.495 1.09 1.1v2.629c0 1.634-1.129 3.107-2.727 3.377a3.226 3.226 0 01-1.909-.258V9.625c0-.605-.49-1.1-1.09-1.1h-.819V6.6c0-.605.491-1.1 1.091-1.1zm1.091 1.925a.55.55 0 000 1.1.55.55 0 000-1.1zm2.1 2.96h-2.03a.277.277 0 01-.24-.413c.213-.363.693-.622 1.255-.622.562 0 1.042.259 1.254.627a.274.274 0 01-.24.407zm-.464-2.41c0 .302.246.55.546.55a.55.55 0 000-1.1.55.55 0 00-.546.55z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09 9.35h4.364c.6 0 1.091.495 1.091 1.1v2.75c0 1.964-1.707 3.531-3.703 3.273C6.195 16.258 5 14.761 5 13.085V10.45c0-.605.49-1.1 1.09-1.1zm1.092 1.925a.55.55 0 000 1.1.55.55 0 000-1.1zm2.345 2.338c-.207.368-.693.627-1.255.627-.561 0-1.041-.259-1.254-.627a.277.277 0 01.24-.413h2.029c.207 0 .344.226.24.413zm-.709-1.788c0 .303.246.55.546.55a.55.55 0 000-1.1.55.55 0 00-.546.55z",
    fill: "#fff"
  })));
}
export default SvgKulturelYerler;